import dJSON from 'dirty-json';

const moduleSelector = '.advantages-cards';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      if (!query.data) return;

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.advantages-grid').insertAdjacentHTML('beforeend', /* html */ `
          ${item.link ? `<a href="${item.link}" class="advantages-card">` : '<div class="advantages-card">'}
          <div class="nFlex">
            ${item.icon ? `<div class="image-wrapper">
              <img src="${item.icon}" alt="${item.title}">
            </div>` : ''}
              <div class="content-wrapper">
                <h4 class="card-title">${item.title}</h4>
                <p class="card-text">${item.text}</p>
              </div>
            </div>
          ${item.link ? '</a>' : '</div>'}
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

/**
 * intersection animation
 */
(() => {
  const observer = new IntersectionObserver((e) => {
    e.forEach((item) => {
      if (item.isIntersecting) {
        item.target.classList.add('section-active');
      } else {
        item.target.classList.remove('section-active');
      }
    });
  });

  document.querySelectorAll('.advantages-grid')
    .forEach((item) => {
      observer.observe(item);
    });
})();
